// extracted by mini-css-extract-plugin
export var standaloneTable = "_28-0";
export var standaloneTableWithBodyFill = "_28-1";
export var withExtraHeader = "_28-2";